import * as React from 'react';
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import {resourcesHelper} from "@ferry/portal-core";

interface IProps {
    modalContent: React.ReactNode;
    onClose?: () => void;
    headerText?: string;
}

interface IState {
    isOpen: boolean;
}

export class SuccessfulPurchaseModal extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: true
        }

        this.close = this.close.bind(this);
    }

    public render(): React.ReactNode {
        const closeBtn = <button className="btn-close" onClick={this.close}/>

        return (
            <Modal className="falcon-modal purchase-success-modal tablet-w-100-procent" isOpen={this.state.isOpen}>
                <ModalHeader close={closeBtn} >
                    <div className="d-flex title-container">
                        <div className="d-flex purchase-success-icon-container">
                            <img className="purchase-success-icon d-block"
                                 src={`/${resourcesHelper.THEME_PATH}/img/check-mark-green-light.svg`}
                                 alt="Payment complete"
                                 aria-label="Payment complete"
                                 tabIndex={0}
                            />
                            <h1 id="success-modal-title" className="success-modal-title">{this.props.headerText? this.props.headerText : "All done"}</h1>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody className="pt-0">
                    <div className="success-modal-content">
                        {this.props.modalContent}
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button type="button"
                        className="btn btn-primary btn-blue-dashboard"
                        onClick={this.close}
                    >
                        Get started
                    </button>
                </ModalFooter>
            </Modal>
        )
    }

    private close(): void {
        window.sessionStorage.removeItem("showPopup");

        this.setState({
            isOpen: false
        });

        if (this.props.onClose) {
            this.props.onClose();
        }
    }

}
